module.exports = __webpack_public_path__ + "static/media/github-logo.b06eabd4.svg";